import {
  createOrgSettings,
  // deleteOrgSettings,
  getOrgSettings,
  updateOrgSettings,
} from 'admin/services/orgSettingsService';
import { useEffect, useState } from 'react';

export const usePlatformCharge = () => {
  const [data, setData] = useState<{
    id: string;
    platformCharge: number;
  } | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPlatformCharge = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await getOrgSettings();
      setData(res);
    } catch (error) {
      console.error(error);
      setError('Failed to load settings');
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  const savePlatformCharge = async (platformCharge: number) => {
    try {
      setError(null);
      if (platformCharge < 0 || platformCharge > 1) {
        throw new Error('Platform charge must be between 0 and 1');
      }
      if (data?.id) {
        await updateOrgSettings(data.id, platformCharge);
      } else {
        await createOrgSettings(platformCharge);
      }
      await fetchPlatformCharge();
    } catch (error) {
      console.error('Error saving platform charge:', error);
      setError('Failed to save platform charge');
      throw error;
    }
  };

  // const deletePlatformCharge = async () => {
  //   if (!data?.id) {
  //     throw new Error('No platform charge to delete');
  //   }
  //   try {
  //     setLoading(true);
  //     await deleteOrgSettings(data.id);
  //     setData(null);
  //     setError(null);
  //     await fetchPlatformCharge();
  //   } catch (error) {
  //     console.error('Error deleting platform charge:', error);
  //     setError('Failed to delete platform charge');
  //     throw error;
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  useEffect(() => {
    fetchPlatformCharge();
  }, []);

  return {
    data,
    // deletePlatformCharge,
    error,
    loading,
    platformCharge: data?.platformCharge ?? null,
    savePlatformCharge,
  };
};
